<section class="change-notification flex row align-center justify-content-between">
  <label class="change-notification__label">{{ changeNotificationLabel }}</label>
  <app-toggle
    [changeNotificationChecked]="changeNotificationChecked"
    (changeNotificationValue)="emitChangeNotificationValue($event)"
  ></app-toggle>
</section>
